import { usePaymentOverviewApiV1PaymentsOverviewGet } from '#/shared/api/generated/billing/theCargoBilling'
import { formatUsd } from '#/shared/lib/format'

export interface UseShipmentPaidResult {
  /** Formatted money, or `undefined` until the request lands — render a dash
   *  for that, never $0.00, so nobody reads "unpaid" off an in-flight call. */
  paid: string | undefined
  isLoading: boolean
}

/**
 * Money actually taken across every payment on the order, net of refunds.
 * `deposit` on the shipment is only what someone typed at booking and never
 * moves when money arrives, so the two disagree on 43% of orders that have
 * payments. Billing caches this and evicts it on every payment write, so it
 * is cheap to ask for and never stale.
 */
export function useShipmentPaid(
  shipmentId: string | undefined,
): UseShipmentPaidResult {
  const armed = Boolean(shipmentId)
  const query = usePaymentOverviewApiV1PaymentsOverviewGet(
    { shipment_id: shipmentId ?? '' },
    { query: { enabled: armed } },
  )
  const paid: unknown = query.data?.data?.paid
  return {
    paid:
      typeof paid === 'number' ? formatUsd(paid, { showCents: true }) : undefined,
    isLoading: query.isLoading && armed,
  }
}
